import type { AnalysisListItem } from '@/entities/analysis';
import { useDeleteAnalysis, useRetryAnalysis } from '../../../../model/useAnalyses';
import { AnalysisTable } from '../AnalysisTable';

interface AnalysisListViewProps {
  analyses: AnalysisListItem[];
}

export function AnalysisListView({ analyses }: AnalysisListViewProps) {
  const retryMutation = useRetryAnalysis();
  const deleteMutation = useDeleteAnalysis();

  return (
    <AnalysisTable
      analyses={analyses}
      onRetry={(id) => retryMutation.mutate(id)}
      onDelete={(id, options) => deleteMutation.mutate(id, options)}
      retryingId={retryMutation.isPending ? retryMutation.variables : undefined}
      deletingId={deleteMutation.isPending ? deleteMutation.variables : undefined}
    />
  );
}
